<template>
  <v-card rounded="lg" elevation="9" ripple @click="gotoTopic">
    <div
      class="justify-start flex-lg-row flex-xl-row flex-xs-column flex-sm-column d-flex align-center"
    >
      <v-img
        :src="image"
        :lazy-src="require('@/assets/img/logo.png')"
        max-width="280px"
        height="100%"
        :class="{
          'rounded-l-lg': $vuetify.breakpoint.mdAndUp,
          'rounded-t-lg': $vuetify.breakpoint.smAndDown
        }"
      />
      <div class="d-flex flex-column">
        <v-card-title
          class="text-xs-h5 text-sm-h5 text-md-h4 text-lg-h4 font-weight-semibold"
          >{{ title }}</v-card-title
        >
        <v-card-subtitle
          class="my-1 text-subtitle-1 text-trunicate d-inline-block"
        >
          <span v-html="body"></span>
        </v-card-subtitle>
        <v-card-text
          class="flex-row justify-start d-flex align-center d-flex-wrap"
        >
          <div
            class="justify-center rounded-lg pa-3 text-subtitle-1 align-center d-inline-block primary white--text"
            v-for="category in categories"
            :key="category"
          >
            <p class="text-trunicate ma-0 pa-0">{{ category }}</p>
          </div>
          <div class="mx-5">
            <v-icon color="primary">forum</v-icon>
            <span class="mx-2 text-body-1">{{ comments }}</span>
          </div>
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'ForumEntry',
  props: ['id', 'title', 'date', 'image', 'body', 'categories', 'comments'],
  methods: {
    gotoTopic() {
      this.$router.push({ name: 'ViewForum', params: { id: this.id } })
    }
  }
}
</script>

<style></style>
